<template>
  <div class="carousel-frame" style="width: 100%">
    <el-carousel trigger="click" height="500px" style="width: 100%">
      <el-carousel-item v-for="(item, index) in carouselData" :key="index">
        <div
          class="item-frame"
          :style="{
            width: '100%',
            height: '100%',
            'background-image': `url(${item.url})`,
          }"
        >
          <div class="item-content container flex-display flex-row-between">
            <div
              class="left"
              :class="{
                'padding-90': item.icon ? true : false,
                'padding-110': !item.icon ? true : false,
              }"
            >
              <img
                class="icon"
                width="75px"
                height="75px"
                v-if="item.icon"
                :src="item.icon"
                alt=""
              />
              <div class="title">{{ item.title }}</div>
              <div class="sub-title">
                {{ item.subTitle }}
              </div>
            </div>
            <img
              :src="item.rightImg"
              @click="changeVideo(item)"
              width="780"
              height="100%"
              alt=""
            />
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
    <el-dialog
      :visible.sync="dialogVisible"
      width="70%"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <video
        id="video"
        :preload="preload"
        :poster="videoImg"
        :height="height"
        :width="width"
        align="center"
        :controls="controls"
        :autoplay="autoplay"
      >
        <source :src="videoSrc" type="video/mp4" />
      </video>
    </el-dialog>
  </div>
</template>
<script>
// import { videoPlayer } from 'vue-video-player'
import 'video.js/dist/video-js.css'
export default {
  components: {
    // videoPlayer
  },
  props: {
    carouselData: {
      typeof: Object
    }
  },

  watch: {
    // 监听事件，表单页面关闭时结束视频播放
    'dialogVisible': function (val) {
      if (this.dialogVisible === false) { // visible为表单显示状态
        let myVideo = document.getElementById('video') // 对应video标签的ID
        myVideo.pause()
      }
    }
  },
  data () {
    return {
      dialogVisible: false,
      videoSrc: '',
      videoImg: '',
      playStatus: '',
      muteStatus: '',
      isMute: true,
      isPlay: false,
      width: '100%', // 设置视频播放器的显示宽度（以像素为单位）
      height: 'atuo', // 设置视频播放器的显示高度（以像素为单位）
      preload: 'auto', //  建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
      controls: true, // 确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
      autoplay: ''
    }
  },

  methods: {
    changeVideo (item) {
      if (item.video) {
        this.videoSrc = item.video
        this.dialogVisible = true
      }
    },
    handleClose () {
      this.dialogVisible = false
    }
  }
}
</script>

<style  lang="less" scoped>
// 轮播图
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}
.item-frame {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  .item-content {
    height: 100%;
    .left {
      box-sizing: border-box;
      height: 100%;
      width: 410px;
      padding-left: 40px;

      .icon {
        margin-bottom: 35px;
      }
      .title {
        font-size: 40px;
        font-family: SourceHanSansCN-Medium, SourceHanSansCN;
        font-weight: 500;
        color: #ffffff;
        margin-bottom: 20px;
      }
      .sub-title {
        font-size: 20px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #ffffff;
        line-height: 36px;
      }
    }
    .padding-90 {
      padding-top: 90px;
    }
    .padding-110 {
      padding-top: 110px;
    }
  }
}
.el-carousel__arrow {
  height: 60px;
  width: 60px;
  background: #fff;
}
.el-carousel__arrow i {
  font-size: 30px;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.video-js .vjs-big-play-button {
  top: 43%;
  left: 43%;
}
.video-js .vjs-tech {
  height: 99%;
}
</style>



// WEBPACK FOOTER //
// src/components/common/carousel.vue